import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitStatus('success');
      setEmail('');
      return;
    }
    try {
      const res = await fetch('https://readdy.ai/api/form/d95mf4bjjt5fme3c4vug', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore parse errors */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试');
      }
    } catch (_err) {
      setSubmitStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20warm%20entertainment%20atmosphere%20with%20abstract%20glowing%20amber%20and%20gold%20light%20particles%20floating%20in%20dark%20space%2C%20cinematic%20bokeh%20effect%20with%20soft%20focus%20and%20deep%20shadows%2C%20premium%20exclusive%20VIP%20club%20mood%2C%20elegant%20mysterious%20composition%20with%20rich%20warm%20tones%2C%20velvet%20curtain%20texture%20and%20golden%20sparkle%20highlights%2C%20luxury%20theater%20premiere%20aesthetic&width=1600&height=800&seq=cta-subscribe-bg&orientation=landscape"
          alt="吃瓜不迷路 - 订阅51吃瓜爆料网"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center lg:items-end justify-between gap-10">
          {/* Left: Headline */}
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-4">
              吃瓜不迷路
            </h2>
            <p className="text-background-200/80 text-sm md:text-base leading-relaxed max-w-sm">
              每日最新大瓜直送你的邮箱，
              <br />
              不错过任何一个娱乐圈大事件。
            </p>
          </div>

          {/* Right: Subscribe Form */}
          <div className="lg:w-1/2 w-full max-w-md">
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2" data-readdy-form="">
              <div className="relative flex-1">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱"
                  required
                  className="w-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full py-3 px-5 text-background-50 text-sm outline-none focus:border-primary-400 transition-colors placeholder:text-background-300"
                />
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="website_alt_field"
              />
              <button
                type="submit"
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center gap-2 cursor-pointer"
              >
                立即订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-accent-400 text-xs mt-3">订阅成功！每日大瓜将准时送达！</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-primary-400 text-xs mt-3">{errorMsg}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}